module.exports = __webpack_public_path__ + "static/media/6.558d7dc3.jpeg";